import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { FlowchartGroupResponse } from '../../responses/risk-classification/flowchart-group.response';

@Injectable({
  providedIn: 'root'
})
export class FlowchartGroupService extends CommonService{

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  getFlowchartGroup(): Observable<FlowchartGroupResponse>{
    let uri = `FlowchartGroup`
      
    return this.httpClient.get<FlowchartGroupResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiRiskClassification) + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }
}
